import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';
import { Button } from '@rocco/components/button';

interface PageDetailHeaderCTAProps {
    pageID: number;
    website?: string | null;
    professionalID: number;
    professionalTitle: string;
}

/**
 * The CTA button in the product detail page header.
 */
const PageDetailHeaderCTA = ({
    pageID,
    website,
    professionalID,
    professionalTitle,
}: PageDetailHeaderCTAProps) => {
    const { referralTrackingURL, referralTrackingParams } =
        useWebsiteReferralTracking(website, {
            libraryItemID: pageID,
            professionalID: professionalID,
            professionalTitle,
        });

    return (
        <div className="flex gap-4">
            {referralTrackingURL && (
                <Button
                    color="secondary"
                    weight="default"
                    size="larger"
                    asChild
                >
                    <a
                        href={referralTrackingURL}
                        target="_blank"
                        {...referralTrackingParams}
                        rel="noopener"
                    >
                        Visit Website
                    </a>
                </Button>
            )}
        </div>
    );
};

export default PageDetailHeaderCTA;
